export const declOfNum = (n, text_forms) => {
    n = Math.abs(n) % 100; var n1 = n % 10;
    if (n > 10 && n < 20) { return text_forms[2]; }
    if (n1 > 1 && n1 < 5) { return text_forms[1]; }
    if (n1 === 1) { return text_forms[0]; }
    return text_forms[2];
}

export const checkNameType = (file) => {
    const types = ['.jpg', '.jpeg', '.png', '.gif']
    let res = false
    types.forEach(item => {
        if(file.name.includes(item))
            res = true
    })
    return res
}

export const isFileImage = (file) => {
    return file && file['type'].split('/')[0] === 'image'
}

const isImageFileType = (type) => {
    return !!type && type.indexOf('image/') === 0;
}

export const previewImage = (file, size = 74) => {
    return new Promise(function (resolve) {
        if (!isImageFileType(file.type)) {
            resolve('');
            return;
        }

        var canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        canvas.style.cssText = 'position: fixed; left: 0; top: 0; width: ' + size + 'px; height: ' + size + 'px; z-index: 9999; display: none;';
        document.body.appendChild(canvas);
        var ctx = canvas.getContext('2d');
        var img = new Image();
        img.onload = function () {
            var width = img.width,
                height = img.height;


            var drawWidth = size;
            var drawHeight = size;
            var offsetX = 0;
            var offsetY = 0;

            if (width < height) {
                drawHeight = height * (size / width);
                offsetY = -(drawHeight - drawWidth) / 2;
            } else {
                drawWidth = width * (size / height);
                offsetX = -(drawWidth - drawHeight) / 2;
            }

            ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
            var dataURL = canvas.toDataURL();
            document.body.removeChild(canvas);

            resolve(dataURL);
        };
        img.src = window.URL.createObjectURL(file);
    })
}
